import { useState } from 'react'
import { path, pluck } from 'ramda'
import { UserId } from '@cibo/core'

import { SelectFile, ConfirmFields } from './steps'

enum STEP {
  SELECT_FILE,
  CONFIRM_FIELDS,
}

type UploadFlowProps = {
  onComplete: (fieldIds: string[]) => void
  userId?: UserId
}

export const UploadFlow = ({ onComplete, userId }: UploadFlowProps) => {
  const [step, setStep] = useState(STEP.SELECT_FILE)
  const [fields, setFields] = useState<any[]>()

  const onUpload = (response: any) => {
    const entries = path(['item', 'entries'])(response) as []
    const fields = pluck('refItem', entries)

    setFields(fields)
    setStep(STEP.CONFIRM_FIELDS)
  }

  const handleConfirmed = (uploadedFieldIds: string[]) => {
    onComplete(uploadedFieldIds)
  }

  return (
    <>
      {step === STEP.SELECT_FILE && <SelectFile onUpload={onUpload} />}

      {step === STEP.CONFIRM_FIELDS && !!fields && (
        <ConfirmFields fields={fields} onConfirmed={handleConfirmed} userId={userId} />
      )}
    </>
  )
}
